import { useState } from 'react'
import { surgeryListMockData } from '../utils/mockdata'

const useSurgeryData = () => {
  const [searchText, setSearchText] = useState('')
  const [surgeryTypeFilter, setSurgeryTypeFilter] = useState('all')
  const [urgencyFilter, setUrgencyFilter] = useState('all')
  const [statusFilter, setStatusFilter] = useState('all')
  const [dateRange, setDateRange] = useState(null)

  // Get unique surgery types and other filter values
  const surgeryTypes = [...new Set(surgeryListMockData.map((surgery) => surgery.surgeryType))].sort()
  const surgeons = [...new Set(surgeryListMockData.map((surgery) => surgery.assignedSurgeon))].sort()
  const surgeryRooms = [...new Set(surgeryListMockData.map((surgery) => surgery.surgeryRoom))].sort()

  // Filter the data based on search and filters
  const filteredData = surgeryListMockData.filter((surgery) => {
    // Text search
    const textMatch =
      searchText === '' ||
      surgery.patientName.toLowerCase().includes(searchText.toLowerCase()) ||
      surgery.surgeryType.toLowerCase().includes(searchText.toLowerCase()) ||
      surgery.assignedSurgeon.toLowerCase().includes(searchText.toLowerCase()) ||
      surgery.surgeryId.toLowerCase().includes(searchText.toLowerCase())

    // Surgery type filter
    const typeMatch = surgeryTypeFilter === 'all' || surgery.surgeryType === surgeryTypeFilter

    // Urgency filter
    const urgencyMatch = urgencyFilter === 'all' || surgery.urgency === urgencyFilter

    // Status filter
    const statusMatch = statusFilter === 'all' || surgery.preOpStatus === statusFilter

    // Date range filter
    let dateMatch = true
    if (dateRange && dateRange[0] && dateRange[1]) {
      const surgeryDate = new Date(surgery.scheduledDateTime)
      const startDate = dateRange[0].startOf('day').toDate()
      const endDate = dateRange[1].endOf('day').toDate()
      dateMatch = surgeryDate >= startDate && surgeryDate <= endDate
    }

    return textMatch && typeMatch && urgencyMatch && statusMatch && dateMatch
  })

  // Group surgeries by date for calendar view
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const todaySurgeries = filteredData.filter((surgery) => {
    const surgeryDate = new Date(surgery.scheduledDateTime)
    surgeryDate.setHours(0, 0, 0, 0)
    return surgeryDate.getTime() === today.getTime()
  })

  const tomorrowDate = new Date(today)
  tomorrowDate.setDate(tomorrowDate.getDate() + 1)
  const tomorrowSurgeries = filteredData.filter((surgery) => {
    const surgeryDate = new Date(surgery.scheduledDateTime)
    surgeryDate.setHours(0, 0, 0, 0)
    return surgeryDate.getTime() === tomorrowDate.getTime()
  })

  const futureSurgeries = filteredData.filter((surgery) => {
    const surgeryDate = new Date(surgery.scheduledDateTime)
    surgeryDate.setHours(0, 0, 0, 0)
    return surgeryDate > tomorrowDate
  })

  return {
    searchText,
    setSearchText,
    surgeryTypeFilter,
    setSurgeryTypeFilter,
    urgencyFilter,
    setUrgencyFilter,
    statusFilter,
    setStatusFilter,
    dateRange,
    setDateRange,
    filteredData,
    todaySurgeries,
    tomorrowSurgeries,
    futureSurgeries,
    surgeryTypes,
    surgeons,
    surgeryRooms
  }
}

export default useSurgeryData
